module.exports = __webpack_public_path__ + "static/media/personal-challenge.347165b4.jpg";